import { createFileRoute } from "@tanstack/react-router";

import { ForgotPassword } from "@/views/login/forgot-password";

export const Route = createFileRoute("/_guest/forgot-password")({
  component: ForgotPassword,
});
